export default __webpack_public_path__ + "static/media/photo--lg--kickoff3b.5710731b.jpg";